import { makeObservable, observable, action } from "mobx";

import { LabelValue } from "../../models/Dashboard/Analytics";
import LogisticsAnalyticsDashboardAPI from "../../api/LogisticsAnalyticsDashboardAPI";
import { LogisticsAnalyticsAPIFilters } from "../../models/Dashboard/LogisticsDashboard/LogisticsAnalyticsFilters";
import dayjs from "dayjs";

export class LogisticsAnalyticsDashboardStore {
  analyticsAPI: LogisticsAnalyticsDashboardAPI;
  basic_tats: LabelValue[];

  constructor() {
    this.analyticsAPI = new LogisticsAnalyticsDashboardAPI();
    this.basic_tats = [];

    makeObservable(this, {
      basic_tats: observable,
      getLogisticsAnalyticsTats: action,
    });
  }

  getLogisticsAnalyticsTats = async (filters: LogisticsAnalyticsAPIFilters) => {
    try {
      filters.start_date = dayjs(filters.start_date, "YYYY-MM-DD").format(
        "YYYY-MM-DD HH:mm:ss"
      );

      filters.end_date = dayjs(filters.end_date, "YYYY-MM-DD")
        .add(1, "day")
        .subtract(1, "second")
        .format("YYYY-MM-DD HH:mm:ss");

      const data = (await this.analyticsAPI.getTatsData(
        "/tats",
        filters
      )) as LabelValue[];
      this.basic_tats = data;
    } catch (error) {
      console.error("Error fetching Data", error);
    }
  };
}
